export default [
    { //中介服务列表
        path: '/agentManagement',
        name:'agentManagement',
        meta: { title: '中介服务列表'},
        component: () => import('../../views/agentManagement/index.vue')
    },
    { //中介服务明细
        path: '/agentManagement/detail',
        name:'agentManagementDetail',
        meta: { title: '中介服务明细'},
        component: () => import('../../views/agentManagement/detail.vue')
    },
    { //编辑中介服务
        path: '/agentManagement/edit',
        name:'agentManagementEdit',
        meta: { title: '发布中介服务'},
        component: () => import('../../views/agentManagement/edit.vue')
    },
    { //发布中介服务
      path: '/agentManagement/add',
      name:'agentManagementAdd',
      meta: { title: '发布中介服务'},
      component: () => import('../../views/agentManagement/add.vue')
  },
]